import React, { useState, Fragment, useEffect } from 'react';
import Permissions from '../../Shared/Permissions';
import { useDispatch, useSelector } from 'react-redux';
import { verifyUser, dispatchVerifyActions, updateUserProfile } from '../../api/dashboardApi';
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import NoPermission from '../../common/NoPermission';

const EditPermissions = (props = {}) => {
    const [facultyId, setFacultyId] = useState('');
    const {permissions = {}, isSuperAdmin} = props;

    const dispatch = useDispatch();
    const verifyAndSearchUser = (e, cb) => dispatch(verifyUser(e, cb));
    const clearFlags = () => dispatch(dispatchVerifyActions());
    const updateProfile = (e, cb) => dispatch(updateUserProfile(e, cb, false));

    const state = useSelector(state => state);
    const { dashboardReducer: { verifyApiCalled, verificationSuccess, userPermissions, isVerifyingUser, isUserSuperAdmin,
        searchId } = {} } = state || {};

    useEffect(() => {
        clearFlags();
    }, []);

    const onButtonClick = () => {
        const searchErrorCallback = () => toast.error('Error Occured. Please try again...', {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
        });
        const callbacks = {
            searchErrorCallback,
            fetchProfile: true
        }
        clearFlags();
        verifyAndSearchUser(facultyId, callbacks);
    }

    const successCallback = (message, type) => {
        toast(message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: false,
            progress: undefined,
            type: type
        });
        clearFlags();
        setFacultyId('');
    }

    let customClass = "";
    if (verifyApiCalled) {
        if (verificationSuccess) {
            customClass = "success";
        } else {
            customClass = "failed";
        }
    }

    if (!isSuperAdmin && !permissions.update) {
        return <NoPermission />;
    }

    return (
        <Fragment>
            <div className="section-body mt-4">
                <div className="container-fluid">
                    <div className="col-md-9 row">
                        <label className="col-md-3 col-form-label">
                            Enter Faculty Id<span className="text-danger">*</span>
                        </label>
                        <div className="col-md-6">
                            <input
                                type="text"
                                className={`form-control ${customClass}`}
                                value={facultyId}
                                onChange={(e) => setFacultyId(e.target.value)}
                                onKeyUp={(e) => {e.keyCode === 13 && onButtonClick()}}
                            />
                        </div>
                        <button
                            id="search-user-btn"
                            className="btn btn-primary col-md-3"
                            disabled={!facultyId || isVerifyingUser}
                            type="button"
                            onClick={onButtonClick}
                        >
                            {isVerifyingUser ? <i className="fa fa-circle-o-notch fa-spin fa-fw"></i> : 'Search'}
                        </button>
                    </div>
                    <hr />
                    {Object.keys(userPermissions).length > 0 && (
                        <div className='card'>
                            <Permissions
                                isEditPermission
                                userPermissions={userPermissions}
                                isUserAdmin={isUserSuperAdmin}
                                updateProfile={updateProfile}
                                searchId={searchId}
                                successCallback={successCallback} />
                        </div>)}
                </div>
            </div>
            <ToastContainer />
        </Fragment>
    );
}

export default EditPermissions;